import {
    Component,
    SimpleChanges,
    ViewChildren,
    Input,
    QueryList,
    OnChanges,
    Output,
    EventEmitter
} from '@angular/core';
import { FilterBase } from 'src/app/shared/grid/filter-base';
import { GridFilterPopupComponent } from 'src/app/shared/grid/filters/base-filter-popup.component';
import { GridDateRangeFilterComponent } from 'src/app/shared/grid/filters/grid-date-range-filter.component';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

@Component({
    selector: 'grid-date-range-filter-popup',
    template: `
        <grid-filter-popup
            [isFilterActive]="isFilterActive"
            [disableClear]="disableClear"
            (onResetClick)="onResetClick()"
            (onFilterClick)="onFilterClick()"
            (onClose)="onPopupClose()">
            <grid-date-range-filter
                [field]="field"
                [filter]="filter"
                [filterService]="filterService"
                (filterValueChanged)="filterValueChanged()"
                [allowSameDaySelection]="allowSameDaySelection"
                [submitOnChange]="false"
                [labelBefore]="labelBefore"
                [labelAfter]="labelAfter">
            </grid-date-range-filter>
        </grid-filter-popup>
    `,
    standalone: true,
    imports: [GridFilterPopupComponent, GridDateRangeFilterComponent]
})
export class GridDateRangeFilterPopupComponent extends FilterBase implements OnChanges {
    isFilterActive = false;

    @Input() disableClear = false;
    @Input() allowSameDaySelection = false;
    @Output() onClearFilter = new EventEmitter<boolean>();
    @ViewChildren(FilterBase) filters: QueryList<FilterBase>;

    filterValueChanged() {
        const fromDate = this.getLatestFilterValue(null, this.field + 'From');
        const toDate = this.getLatestFilterValue(null, this.field + 'To');
        this.isFilterActive = !isEmpty(fromDate) || !isEmpty(toDate);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['filter']) {
            this.filterValueChanged();
        }
    }

    onResetClick(): void {
        this.trimFilterByField(this.filter, this.field + 'From');
        this.trimFilterByField(this.filter, this.field + 'To');
        this.submitFilter();
        this.filterValueChanged();
        this.onClearFilter.emit(true);
    }

    onFilterClick(): void {
        this.submitFilter();
    }

    onPopupClose(): void {
        if (this.filters.toArray().some((x) => x.isChanged)) {
            this.submitFilter();
        }
    }

    submitFilter() {
        this.filters.toArray().forEach((x) => (x.isChanged = false));
        super.submitFilter();
    }
}
